import React from "react";

import { Text } from "@performyard/py-components";

/** Header for the user-facing Meetings Integrations settings view. */
export const MeetingsIntegrationsHeader = (): React.ReactElement => {
	return (
		<div className="flex w-full flex-col gap-1">
			<Text size="paragraph-1" weight="semi-bold">
				Meetings Integrations
			</Text>
			<Text size="paragraph-3" weight="regular">
				Connect your tools to get the most out of PerformYard meetings.
			</Text>
		</div>
	);
};
